import postClientError from './postClientError';
import { logger } from './telemetry';
import {
  MAX_STACK_LENGTH,
  redact,
  scrubError,
  toError,
} from './telemetry/scrub';

/**
 * Reports an error caught by an ErrorBoundary to both channels.
 *
 * Separate from sendError because a render error deserves its own grouping key. The component
 * name is a bounded set, so "React render error in {Component}" stays a useful signature, where
 * routing render errors through sendError would bucket them all as unclassified.
 *
 * The component stack is what actually locates a render error, so it is sent as the stack trace
 * -- matching what the ErrorBoundary did before -- rather than the JS stack.
 */
export default function reportRenderError(error, componentStack, component) {
  try {
    const Component = component || 'unknown';
    const { error: raw } = toError(error);
    const reportable = scrubError(raw);
    const stack = redact(componentStack ?? '', MAX_STACK_LENGTH);

    logger.error(
      'React render error in {Component}',
      {
        Component,
        ComponentStack: stack,
        ErrorType: 'Render',
        ExceptionType: raw.name,
      },
      reportable
    );

    postClientError({
      type: 'Render',
      errorMessage: reportable.message,
      stackTrace: stack,
      url: window.location.href,
    });
  } catch {
    // A boundary is the last line of defence; it must not throw while reporting.
  }
}
